import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import FinOpsGerenteDashboard from './FinOpsGerenteDashboard';
// import FinOpsCoordinadorDashboard from './FinOpsCoordinadorDashboard';
// import FinOpsAnalistaDashboard from './FinOpsAnalistaDashboard';

export default function FinopsDashboard() {
  const { user } = useAuth();

  // Determinar qué dashboard mostrar según el rol
  const role = user?.role?.toLowerCase();

  // Por ahora, todos ven el dashboard de gerente
  // Más adelante se pueden crear dashboards específicos por rol
  if (role === 'finops_gerente' || role === 'finops_coordinador' || role === 'finops_analista') {
    return <FinOpsGerenteDashboard />;
  }

  // Default: mostrar dashboard de gerente
  return <FinOpsGerenteDashboard />;
}
